// removed by extract-text-webpack-plugin
module.exports = {"name":"name__nE_Th","variant":"variant__3Uye9","divider":"divider__zUPoq","price":"price__22hhQ","symbol":"symbol__3cFQB","shipping":"shipping__3DmjL"};


//////////////////
// WEBPACK FOOTER
// ./components/blocks/raffleDetail/styles/HeaderArea.scss
// module id = F481
// module chunks = 1